export default __webpack_public_path__ + "static/imgform-a09783f006d2ba29b1dc03293d524113.png";